import { post } from "shared/data";
import { setSourcePage } from "components/attributes/lib/attribute-data";

export const setTaskPriority = (priority, taskContextKeys, taskTypes) => {
    const usePriority = priority === "null" ? "" : priority;
    const payload = {
        contextLookupType: "taskContextKey",
        contextLookupKeys: taskContextKeys,
        includeTaskTypes: taskTypes,
        excludeTaskTypes: [],
    };

    return post(`/tasking/tasks/assignment/priority/${usePriority}`, payload);
};

export const setProfilingPriority = (priority, taskKeys) => {
    const usePriority = priority === "null" ? "" : priority;
    const payload = {
        contextLookupType: "ShipmentKey",
        contextLookupKeys: taskKeys,
        excludeTaskTypes: [],
    };

    return post(`/tasking/tasks/assignment/priority/${usePriority}`, payload);
};

export const setWorkflowTaskPriority = (priority, taskKeys, taskType) => {
    const usePriority = priority === "" ? null : parseInt(priority);
    const payload = {
        priority: usePriority,
        assignmentKeys: taskKeys,
    };

    return post(`/workflow-assignments/${taskType}/priority`, payload);
};

export const setTaskGroup = (sourcePage, group, taskContextKeys, assignedUser, taskTypes, taskKeys) => {
    const useGroup = group === "null" ? "" : group;
    const useUser = assignedUser === "Available" ? null : assignedUser;
    const payload = {
        contextLookupType: "taskContextKey",
        contextLookupKeys: taskContextKeys,
        includeTaskTypes: taskTypes,
        excludeTaskTypes: [],
        assignToUserId: useUser,
        taskKeys: taskKeys,
    };

    return post(`/tasking/tasks/assignment/group/${useGroup}${setSourcePage(sourcePage, true)}`, payload, { noRedirect: true });
};

export const setProfilingGroup = (sourcePage, group, shipmentKeys, assignedUser) => {
    const useGroup = group === "null" ? "" : group;
    const useUser = assignedUser === "Available" ? null : assignedUser;
    const payload = {
        contextLookupType: "ShipmentKey",
        contextLookupKeys: shipmentKeys,
        assignToUserId: useUser,
    };

    return post(`/tasking/tasks/assignment/group/${useGroup}${setSourcePage(sourcePage, true)}`, payload, {
        noRedirect: true,
        defaultReturn: { groupKey: useGroup, taskKey: [...shipmentKeys], success: true },
    });
};

export const setWorkflowTaskAssignment = (sourcePage, group, taskKeys, assignedUser, taskType) => {
    const useGroup = group === "null" ? null : group;
    const useUser = assignedUser === "" ? null : parseInt(assignedUser);
    const payload = {
        assignmentGroupKey: useGroup,
        assignedUserId: useUser,
        assignmentKeys: taskKeys,
    };

    return post(`/workflow-assignments/${taskType}/group${setSourcePage(sourcePage, true)}`, payload, { noRedirect: true });
};
